import simbApi from ".";
import { WORKSPACES_AND_BOARDS } from "../../data/constants/endpoints";
import logger from "../../lib/logger";

interface Board {
  id: number;
  name: string;
}

interface Workspace {
  id: number;
  name: string;
  boards: Board[];
}

interface ApiResponse<T> {
  data: T;
  error?: boolean;
  message?: string;
}

export const getWorkspacesAndBoards = async (access_token: string | null, itemIdsArray: number[], currentBoard: number | null): Promise<Workspace[] | null> => {
  try {
    const response = await simbApi.post<ApiResponse<Workspace[]>>(
      WORKSPACES_AND_BOARDS,
      {
        itemid: itemIdsArray,
        boardid: currentBoard,
      },
      { headers: { Authorization: `Bearer ${access_token}` } },
    );

    return response?.data?.data;
  } catch (error: any) {
    logger.error("axios request:", error);
    throw error;
  }
};
